export function initForms($) {
    const $form = $('#send_contact_form');
    if (!$form.length) return;

    const $submit = $form.find('button[type="submit"]');
    let $message = $('#form-response-message');

    if (typeof $form === 'undefined') {
        return;
    }

    function renderResponseMessage(text, type) {
        const className = type === 'success'
            ? 'bg-neutral-100 border border-neutral-300 text-neutral-900'
            : 'bg-rose-100 border border-rose-300 text-rose-900';

        if (!$message.length) {
            $message = $('<div id="form-response-message" class="max-w-3xl mt-4 mx-auto rounded px-4 py-3 text-sm"></div>');
            $form.after($message);
        }

        $message
            .attr('class', `max-w-3xl mt-4 mx-auto rounded px-4 py-3 text-sm ${className}`)
            .text(text);
    }

    function clearResponseMessage() {
        $message.remove();
        $message = $form.find('.form-response-message');
    }

    function setButtonState(state) {
        switch (state) {
            case 'idle':
                $submit
                    .text('Send')
                    .prop('disabled', false)
                    .css({
                        opacity: '1',
                        filter: 'none'
                    });
                break;

            case 'loading':
                $submit
                    .text('Sending...')
                    .prop('disabled', true)
                    .css({
                        opacity: '0.5',
                        filter: 'grayscale(100%)'
                    });
                break;

            case 'success':
                $submit
                    .text('Message sent!')
                    .prop('disabled', true)
                    .css({
                        opacity: '1',
                        filter: 'none'
                    });
                break;

            case 'error':
                $submit
                    .text('Try again')
                    .prop('disabled', false)
                    .css({
                        opacity: '1',
                        filter: 'none'
                    });
                break;
        }
    }

    $form.on('submit', function (e) {
        e.preventDefault();

        if ($submit.prop('disabled')) return;

        clearResponseMessage();
        setButtonState('loading');

        const formData = new FormData(this);
        
        // Use nonce from DOM if available, fallback to localized script
        const nonce = document.querySelector('input[name="nonce"]')?.value 
            || (typeof send_contact_form !== 'undefined' ? send_contact_form.nonce : null);
        
        if (nonce) {
            formData.append('nonce', nonce);
        }

        $.ajax({
            url: send_contact_form.ajax_url,
            type: 'POST',
            data: formData,
            processData: false,
            contentType: false,
            timeout: 10000
        }).done(function (res) {
            const message = res?.data?.message || 'Message sent';

            if (res?.success) {
                renderResponseMessage(message, 'success');
                setButtonState('success');
                $form[0].reset();
                setTimeout(() => {
                    setButtonState('idle');
                }, 2000);
            } else {
                renderResponseMessage(message, 'error');
                setButtonState('error');
            }
        }).fail(function (res) {
            const errorMessage = res?.responseJSON?.data?.message || 'An error occurred during submission. Please wait a few seconds and try again.';
            renderResponseMessage(errorMessage, 'error');
            setButtonState('error');
        });
    });
}